/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NaturalLanguageTextSpan,
    NaturalLanguageTextSpanFromJSON,
    NaturalLanguageTextSpanFromJSONTyped,
    NaturalLanguageTextSpanToJSON,
} from './NaturalLanguageTextSpan';

/**
 * Google Natural Language API entity mention object (https://cloud.google.com/natural-language/docs/reference/rest/v1/Entity?hl=ja#EntityMention)
 * @export
 * @interface NaturalLanguageEntityMention
 */
export interface NaturalLanguageEntityMention {
    /**
     * 
     * @type {NaturalLanguageTextSpan}
     * @memberof NaturalLanguageEntityMention
     */
    text: NaturalLanguageTextSpan;
    /**
     * The type of the entity mention.
     * @type {string}
     * @memberof NaturalLanguageEntityMention
     */
    type: NaturalLanguageEntityMentionTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum NaturalLanguageEntityMentionTypeEnum {
    TypeUnknown = 'TYPE_UNKNOWN',
    Proper = 'PROPER',
    Common = 'COMMON'
}

export function NaturalLanguageEntityMentionFromJSON(json: any): NaturalLanguageEntityMention {
    return NaturalLanguageEntityMentionFromJSONTyped(json, false);
}

export function NaturalLanguageEntityMentionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NaturalLanguageEntityMention {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': NaturalLanguageTextSpanFromJSON(json['text']),
        'type': json['type'],
    };
}

export function NaturalLanguageEntityMentionToJSON(value?: NaturalLanguageEntityMention | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': NaturalLanguageTextSpanToJSON(value.text),
        'type': value.type,
    };
}

